import "./App.css";
import Header from "./components/header";
import StakeBanner from "./components/stakebanner";
import StakeHeader from "./components/stakeheader";
import StakeStats from "./components/stakestats";
import StakeBody from "./components/stakebody";
import Footer from "./components/footer";
import "./styles/App.css";

import { configVars } from "./config/config.ts";
import React, { useEffect, useState } from "react";
import { ethers, providers } from "ethers";
import Web3Modal from "web3modal";
import ClipLoader from "react-spinners/ClipLoader";
import {providerOptions} from "./config/ProviderOptions";

// Utils for Node
function App() {
  const [loading, setLoading] = useState(false);
  const [availableNFTs, setAvailableNFTs] = useState("");
  const [walletAddress, setAddress] = useState("");
  const [signer, setSigner] = useState("");
  const [claimableReward, setClaimableReward] = useState("");
  const [trpzBalance, setTrpzBalance] = useState("");
  const [library, setLibrary] = useState("");
  const [totalReward, setTotalReward] = useState(0);

  const [stakedNFTList, setStakedNFTList] = useState([]);
  const [stakedNFTCount, setStakedNFTCount] = useState([]);
  const [stakedNFTs, setStakedNFTs] = useState([]);
  const [NFTObjects, setNFTObjects] = useState([]);
  const [batchStakeObjects, setBatchStakeObject] = useState([]);
  const [batchUnstakeObjects, setBatchUnstakeObject] = useState([]);
  const [disabled, setDisabled] = useState(true);

  const web3Modal = new Web3Modal({
    network: "cronos",
    providerOptions,
  });

  useEffect(() => {
    async function getBasics() {
      getTrpzBalance();
      await getStakedIds();
    }
    getBasics();
  }, [walletAddress]);

  useEffect(() => {
    async function getAvailable() {
      await getAvailableInfo();
      await getStakedInfo();
      await getClaimableReward();
      setLoading(false);
    }
    getAvailable();
  }, [stakedNFTList]);

  async function connectWallet() {
    try {
      web3Modal.clearCachedProvider();
      const provider = await web3Modal.connect();
      const library = new providers.Web3Provider(provider);
      const { chainId } = await library.getNetwork();
      if (chainId !== 25) {
        alert("Use Cronos network to connect");
      }
      const accounts = await library.listAccounts();
      const signer = library.getSigner();
      setSigner(signer);
      setLibrary(library);
      setAddress(accounts[0]); // TODO: Change back to accounts[0]
    } catch (error) {
      console.log(error);
    }
  }

  async function disconnectWallet() {
    web3Modal.clearCachedProvider();
    setAddress("");
    setTrpzBalance(0);
    setClaimableReward(0);
    setAvailableNFTs(0);
    setTotalReward(0);
    setStakedNFTCount(0);
    window.location.reload();
  }

  async function getTrpzBalance() {
    if (walletAddress === "") return;
    const trpzToken = new ethers.Contract(
      configVars.erc20.trpzToken,
      configVars.abi.trpzToken,
      library
    );
    const balance = await trpzToken.balanceOf(walletAddress);
    setTrpzBalance(balance.toNumber());
  }

  async function getStakedIds() {
    if (walletAddress === "") return;
    const trpzStake = new ethers.Contract(
      configVars.erc20.trpzStake,
      configVars.abi.trpzStake,
      library
    );
    try {
      const response = await trpzStake.getStakedList(walletAddress);
      setStakedNFTList(response);
      setStakedNFTCount(response.length);
      setLoading(true);
    } catch (error) {
      console.log(error);
      setLoading(true);
    }
  }

  async function getStakedInfo() {
    if (walletAddress === "") return;
    const trpzStake = new ethers.Contract(
      configVars.erc20.trpzStake,
      configVars.abi.trpzStake,
      library
    );
    try {
      let stakedObjects = [];
      let rewardSum = 0;
      for (let i = 0; i < stakedNFTList.length; i++) {
        try {
          const [tokenId, contractAddress] = await trpzStake.getStakedNFT(
            stakedNFTList[i]
          );
          const options = {
            method: "GET",
            headers: { accept: "application/json" },
          };
          const response = await fetch(
            `https://api.ebisusbay.com/nft?collection=${contractAddress}&tokenId=${tokenId.toString()}`,
            options
          )
            .then((response) => response.json())
            .then((response) => response.nft)
            .catch((err) => console.error(err));

          let stakedObject = {
            name: response.name,
            tokenId: tokenId.toNumber(),
            tokenAddress: contractAddress,
            tokenImage: response.image,
            dailyReward: configVars.rewardArray[contractAddress.toLowerCase()],
            stakingId: await stakedNFTList[i].toNumber(),
          };
          stakedObjects.push(stakedObject);
          rewardSum += await stakedObject.dailyReward;
        } catch (error) {
          console.log(error);
        }
      }
      setStakedNFTs(stakedObjects);
      setTotalReward(rewardSum);
    } catch (error) {
      alert("An error occured, please reload the page");
      console.log(error);
    }
  }

  async function getAvailableInfo() {
    if (walletAddress === "") return;
    const whitelistArray = configVars.whitelist;
    let addressString = "";
    whitelistArray.forEach(async (contractAddress) => {
      addressString = addressString + contractAddress + ",";
    });
    addressString = addressString.slice(0, -1);

    const options = { method: "GET", headers: { accept: "application/json" } };
    let nfts = []; // Initialize an empty array to store all NFTs.

    let currentPage = 1;
    let totalPages = 1;

    while (currentPage <= totalPages) {
      const response = await fetch(
          `https://api.ebisusbay.com/v2/wallets?wallet=${walletAddress}&collection=${addressString}&pageSize=100&page=${currentPage}`,
          options
      );
      const responseData = await response.json();

      if (!responseData.nfts) {
        console.error("Unexpected API response:", responseData);
        break;
      }

      totalPages = responseData.nfts.totalPages;

      for (let i = 0; i < responseData.nfts.length; i++) {
        try {
          let nftObject = {
            name: responseData.nfts[i].collectionName,
            tokenId: responseData.nfts[i].nftId,
            tokenAddress: responseData.nfts[i].nftAddress,
            tokenURI: responseData.nfts[i].token_uri,
            tokenImage: responseData.nfts[i].image,
            dailyReward: configVars.rewardArray[responseData.nfts[i].nftAddress.toLowerCase()],
          };
          nfts.push(nftObject);
        } catch (error) {
          console.error(error);
        }
      }

      currentPage++;
    }
    setNFTObjects(nfts);
    setAvailableNFTs(nfts.length);
  }

  async function getClaimableReward() {
    if (walletAddress === "") return;
    try {
      const trpzStake = new ethers.Contract(
        configVars.erc20.trpzStake,
        configVars.abi.trpzStake,
        library
      );
      const claimedRewards = (
        await trpzStake.ownerToRewards(walletAddress)
      ).toNumber();
      const reward = (await trpzStake.getRewards(walletAddress)).toNumber();
      const sumRewards = reward + claimedRewards;
      setClaimableReward(sumRewards);
    } catch (error) {
      console.log(error);
    }
  }

  async function claimRewards() {
    if (walletAddress === "") return;
    const trpzStake = new ethers.Contract(
      configVars.erc20.trpzStake,
      configVars.abi.trpzStake,
      signer
    );
    try {
      let response = await trpzStake.connect(signer).updateRewards();
      alert(
        "Just updating your rewards before you claim them. This will take a moment..."
      );
      await response.wait();
    } catch (error) {
      console.log(error);
    }
    try {
      let secondResponse = await trpzStake.connect(signer).withdrawRewards();
      alert("Reward withdrawal sent! Waiting for the transaction to complete.");
      await secondResponse.wait();
      window.location.reload();
    } catch (error) {
      console.log(error);
      alert(
        "Claim did not work! You may not have exceeded the 24 hour window to claim daily rewards"
      );
    }
  }
  async function stakeNFT(abiKey, tokenId) {
    const stakingAddresses = configVars.erc20;
    const abis = configVars.abi;
    let contractName;
    let contractABI;
    for (const [key, value] of Object.entries(stakingAddresses)) {
      if (abiKey === value) {
        contractName = key;
        break;
      }
    }
    for (const [key, value] of Object.entries(abis)) {
      if (key === contractName) {
        contractABI = value;
      }
    }

    try {
      const nftContract = new ethers.Contract(abiKey, contractABI, signer);
      let txResponse = await nftContract
        .connect(signer)
        ["safeTransferFrom(address,address,uint256)"](
          walletAddress,
          configVars.erc20.trpzStake,
          tokenId
        );
      alert(
        "Staking transaction sent! This will take a few moments to complete."
      );
      await txResponse.wait();
      alert(
        "Successfully staked! Your page will be reloaded to reflect the changes"
      );
      window.location.reload();
    } catch (error) {
      alert(
        "Error: Staking attempt did not work. This may be because you haven't staked 1 OG Troopr to unlock whitelist staking or it may be a connection error."
      );
    }
  }

  async function stakeAll() {
    if (stakedNFTList.length === 0) {
      alert("Please stake one OG Trooper before batch staking");
      return;
    }
    alert(
      "Maximum of 25 NFTs will be sent to staking per transaction to ensure success. Multiple contract confirmations may be required before final transaction is sent."
    );
    let tokenIds = [];
    let contractAddresses = [];
    let nftTotal = 0;
    if (NFTObjects.length > 25) {
      nftTotal = 25;
    } else {
      nftTotal = NFTObjects.length;
    }
    for (let i = 0; i < nftTotal; i++) {
      contractAddresses.push(NFTObjects[i].tokenAddress);
      tokenIds.push(NFTObjects[i].tokenId);
    }

    let approvedAddresses = [];
    for (let i = 0; i < nftTotal; i++) {
      if (approvedAddresses.includes(NFTObjects[i].tokenAddress)) {
        continue;
      }
      approvedAddresses.push(NFTObjects[i].tokenAddress);
      const stakingAddresses = configVars.erc20;
      const abis = configVars.abi;
      let contractName;
      let contractABI;

      for (const [key, value] of Object.entries(stakingAddresses)) {
        if (NFTObjects[i].tokenAddress === value) {
          contractName = key;
          break;
        }
      }

      for (const [key, value] of Object.entries(abis)) {
        if (key === contractName) {
          contractABI = value;
        }
      }

      try {
        let readContract = new ethers.Contract(
          NFTObjects[i].tokenAddress,
          contractABI,
          library
        );
        if (
          await readContract.isApprovedForAll(
            walletAddress,
            configVars.erc20.trpzStake
          )
        ) {
          continue;
        } else {
          let writeContract = new ethers.Contract(
            NFTObjects[i].tokenAddress,
            contractABI,
            signer
          );
          let response = await writeContract.setApprovalForAll(
            configVars.erc20.trpzStake,
            true
          );
          alert(
            "Waiting for approval to confirm before next confirmation. Please do not refresh the page..."
          );
          await response.wait();
          console.log(
            await readContract.isApprovedForAll(
              walletAddress,
              configVars.erc20.trpzStake
            )
          );
        }
      } catch (error) {
        alert(
          "Approval transaction did not work! This will mean an NFT collection may not be batch staked. Please continue then review what did not send."
        );
        console.log(error);
      }
    }

    try {
      const trpzStake = new ethers.Contract(
        configVars.erc20.trpzStake,
        configVars.abi.trpzStake,
        signer
      );
      let txResponse = await trpzStake
        .connect(signer)
        .batchDeposit(contractAddresses, tokenIds);
      alert(
        "Batch stake transaction sent! This will take a few moments to complete. DO NOT REFRESH"
      );
      await txResponse.wait();
      alert(
        "Batch stake successful! Your page will be refreshed and you may need to reconnect your wallet"
      );
      window.location.reload();
    } catch (error) {
      alert(
        "The batch send transaction did not work! Please try to do the transaction again."
      );
      console.log(error);
    }
  }

  async function withdrawToken(stakingId) {
    try {
      const trpzStake = new ethers.Contract(
        configVars.erc20.trpzStake,
        configVars.abi.trpzStake,
        signer
      );
      let txResponse = await trpzStake.connect(signer).withdrawToken(stakingId);
      alert(
        "Unstake transaction sent! This will take a few moments to complete."
      );
      await txResponse.wait();
      alert(
        "Successfully unstaked! Your page will be reloaded to reflect the changes."
      );
      window.location.reload();
    } catch (error) {
      alert("Withdraw token transaction did not work! Please try again.");
      console.log(error);
    }
  }

  async function batchWithdraw() {
    try {
      const trpzStake = new ethers.Contract(
        configVars.erc20.trpzStake,
        configVars.abi.trpzStake,
        signer
      );
      let txResponse = await trpzStake.connect(signer).batchWithdrawTokens();
      alert(
        "Batch unstake transaction sent! This will take a few moments to complete."
      );
      await txResponse.wait();
      alert(
        "Successfully batch unstaked! Your page will be reloaded to reflect the changes"
      );
      window.location.reload();
    } catch (error) {
      alert("Batch withdraw did not work! Please try again");
      console.log(error);
    }
  }

  async function selectedBatchStake(nfts) {
    if (stakedNFTList.length === 0) {
      alert("Please stake one OG Trooper before batch staking");
      return;
    }
    alert(
      "Maximum of 25 NFTs will be sent to staking per transaction to ensure success. Multiple contract confirmations may be required before final transaction is sent."
    );
    let tokenIds = [];
    let contractAddresses = [];
    let nftTotal = 0;

    if (nfts.length > 25) {
      nftTotal = 25;
    } else {
      nftTotal = nfts.length;
    }

    for (let i = 0; i < nftTotal; i++) {
      contractAddresses.push(nfts[i].tokenAddress);
      tokenIds.push(nfts[i].tokenId);
    }

    let approvedAddresses = [];
    for (let i = 0; i < nftTotal; i++) {
      if (approvedAddresses.includes(nfts[i].tokenAddress)) {
        continue;
      }
      approvedAddresses.push(nfts[i].tokenAddress);
      const stakingAddresses = configVars.erc20;
      const abis = configVars.abi;
      let contractName;
      let contractABI;

      for (const [key, value] of Object.entries(stakingAddresses)) {
        if (nfts[i].tokenAddress === value) {
          contractName = key;
          break;
        }
      }

      for (const [key, value] of Object.entries(abis)) {
        if (key === contractName) {
          contractABI = value;
        }
      }

      try {
        let readContract = new ethers.Contract(
          nfts[i].tokenAddress,
          contractABI,
          library
        );
        if (
          await readContract.isApprovedForAll(
            walletAddress,
            configVars.erc20.trpzStake
          )
        ) {
          continue;
        } else {
          let writeContract = new ethers.Contract(
            nfts[i].tokenAddress,
            contractABI,
            signer
          );
          let response = await writeContract.setApprovalForAll(
            configVars.erc20.trpzStake,
            true
          );
          alert(
            "Waiting for approval to confirm before next confirmation. Please do not refresh the page..."
          );
          await response.wait();
          console.log(
            await readContract.isApprovedForAll(
              walletAddress,
              configVars.erc20.trpzStake
            )
          );
        }
      } catch (error) {
        alert(
          "Approval transaction did not work! This will mean an NFT collection may not be batch staked. Please continue then review what did not send."
        );
        console.log(error);
      }
    }
    try {
      const trpzStake = new ethers.Contract(
        configVars.erc20.trpzStake,
        configVars.abi.trpzStake,
        signer
      );
      let txResponse = await trpzStake
        .connect(signer)
        .batchDeposit(contractAddresses, tokenIds);
      alert(
        "Batch stake transaction sent! This will take a few moments to complete. DO NOT REFRESH"
      );
      await txResponse.wait();
      alert(
        "Batch stake successful! Your page will be refreshed and you may need to reconnect your wallet"
      );
      window.location.reload();
    } catch (error) {
      alert(
        "The batch send transaction did not work! Please try to do the transaction again."
      );
      console.log(error);
    }
  }

  async function addStakeInfo(index, contractAddress, tokenId) {
    if (batchStakeObjects.length === 25) {
      alert(
        "You can only stake 25 NFTs at a time. An NFT will be removed from the front of the list."
      );
      batchStakeObjects.shift();
    }
    if (batchStakeObjects.some((e) => e.index === index)) {
      let updatedObjects = batchStakeObjects.filter((e) => e.index !== index);
      setBatchStakeObject(updatedObjects);
    } else {
      let object = {
        index: index,
        tokenAddress: contractAddress,
        tokenId: tokenId,
      };
      setBatchStakeObject((batchStakeObjects) => [
        ...batchStakeObjects,
        object,
      ]);
    }
    if (batchStakeObjects.length >= 0) {
      setDisabled(false);
    } else {
      setDisabled(true);
    }
  }

  async function addUnstakeInfo(index, contractAddress, tokenId) {
    if (batchUnstakeObjects.some((e) => e.index === index)) {
      let updatedObjects = batchUnstakeObjects.filter((e) => e.index !== index);
      setBatchUnstakeObject(updatedObjects);
    } else {
      let object = {
        index: index,
        tokenAddress: contractAddress,
        tokenId: tokenId,
      };
      setBatchUnstakeObject((batchUnstakeObjects) => [
        ...batchUnstakeObjects,
        object,
      ]);
    }
  }

  return (
    <div className="App">
      <Header
        setAddress={setAddress}
        walletAddress={walletAddress}
        availableNFTs={availableNFTs}
        setAvailableNFTs={setAvailableNFTs}
        signer={signer}
        setSigner={setSigner}
        connectWallet={connectWallet}
        disconnectWallet={disconnectWallet}
      />
      <StakeBanner trpzBalance={trpzBalance} />
      <StakeHeader
        claimableReward={claimableReward}
        claimRewards={claimRewards}
      />
      <StakeStats
        availableNFTs={availableNFTs}
        stakedNFTCount={stakedNFTCount}
        totalReward={totalReward}
        claimableReward={claimableReward}
      />
      {loading ? (
        <ClipLoader color={"#D0021B"} loading={loading} size={150} />
      ) : (
        <StakeBody
          stakedNFTs={stakedNFTs}
          NFTObjects={NFTObjects}
          stakeNFT={stakeNFT}
          stakeAll={stakeAll}
          withdrawToken={withdrawToken}
          batchWithdraw={batchWithdraw}
          addStakeInfo={addStakeInfo}
          addUnstakeInfo={addUnstakeInfo}
          selectedBatchStake={selectedBatchStake}
          batchStakeObjects={batchStakeObjects}
          batchUnstakeObjects={batchUnstakeObjects}
          disabled={disabled}
        />
      )}
      <Footer />
    </div>
  );
}

export default App;
